
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ExamVersionInfo } from "@/lib/model/exambuilder/exam-component/exam";
import Pop from "../components/blue-pop.vue";
import InputNumberV3 from "@/views/ai-builder-v3/components/inputNumberV3.vue";
import IntroduceCard from "../components/introduce-card.vue";
import HinaSwitch from "../baseComponent/hina-switch.vue";
import HinaRadioGroup from "../baseComponent/hina-radio-group.vue";
import HinaCheckboxGroup from "../baseComponent/hina-checkbox-group.vue";
import HinaUpload from "@/views/ai-builder-component/baseComponent/hina-upload.vue";

@Component({
  components: {
    HinaUpload,
    HinaCheckboxGroup,
    HinaRadioGroup,
    HinaSwitch,
    Pop,
    InputNumberV3,
    IntroduceCard
  }
})
export default class aiWatchingScreen extends Vue {
  @Prop() formItemData!: ExamVersionInfo; // 组件数据
  @Prop({ default: "" }) builder!: string; // 创建面试来源

  get useScreenshot() {
    return this.formItemData.screenshotDetection.use === 1;
  }

  get useJumpOut() {
    return this.formItemData.jumpOutDetection.use === 1;
  }

  get watermark() {
    return this.formItemData.watermark;
  }

  get screenshot() {
    return this.formItemData.screenshotDetection;
  }

  get screenshotSubmit() {
    return this.screenshot.configData.violationNumber > 0;
  }
  set screenshotSubmit(val: boolean) {
    this.screenshot.configData.violationNumber = val ? 2 : 0;
  }

  get jumpOut() {
    return this.formItemData.jumpOutDetection;
  }

  get jumpOutSubmit() {
    return this.jumpOut.configData.violationNumber > 0;
  }
  set jumpOutSubmit(val: boolean) {
    this.jumpOut.configData.violationNumber = val ? 2 : 0;
  }

  trialOne() {
    this.$emit("trial", "aiWatchingScreen");
  }

  watermarkListOptions = [
    { name: "候选人姓名", value: 1 },
    { name: "候选人姓名 + 手机尾号后4位", value: 2 }
  ];
  screenshotWhiteListOptions = [
    { name: "面试结束页", value: "descAfter", disabled: true },
    { name: "模拟练习页", value: "testExam" }
  ];

  setGlobal() {
    this.$emit("setGlobal");
  }

  @Watch("jumpOut.configData.violationNumber", { immediate: true })
  handleJumpOutNumChange() {
    this.jumpOut.configData.warning.severe.violationNumber = this.jumpOut.configData.violationNumber;
    this.jumpOut.configData.warning.moderate.violationNumber =
      this.jumpOut.configData.violationNumber - 1;
    this.jumpOut.configData.warning.mild.violationNumber =
      this.jumpOut.configData.violationNumber - 2;
  }

  @Watch("screenshot.configData.violationNumber", { immediate: true })
  handleScreenNumChange() {
    this.screenshot.configData.screenshotWarning.severe.violationNumber = this.screenshot.configData.violationNumber;
    this.screenshot.configData.screenshotWarning.moderate.violationNumber =
      this.screenshot.configData.violationNumber - 1;
    this.screenshot.configData.screenshotWarning.mild.violationNumber =
      this.screenshot.configData.violationNumber - 2;
  }

  // 校验数据：
  formItemCheck() {
    return new Promise((resolve, reject) => {
      const valid = true;
      if (valid) {
        resolve("");
      } else {
        resolve("AiAnswer");
      }
    });
  }
}
